<template>
  <div class="login">
    <div class="personal-head">
      <div class="head">账号登录</div>
      <div class="logo">
        <img src="@/assets/images/loginlogo.png" alt />
      </div>
      <div class="w580">
        <van-form @submit="handleLogin()" label-width='1rem' label-align='center'>
          <van-field v-model="user.username" placeholder="请输入用户名" left-icon="account" class="back-tran"
            :rules="[{required: true }]">
            <template #label>
              <img src="@/assets/images/account.png" alt="">
            </template>
          </van-field>
          <van-field v-model="user.password" placeholder="请输入您的密码" type="password" left-icon="password"
            class="back-tran" :rules="[{required: true }]">
            <template #label>
              <img src="@/assets/images/password.png" alt="">
            </template>
          </van-field>
          <van-button type="primary" block color="#2DADB1" native-type="submit">登录</van-button>
        </van-form>
        <p>忘记密码，请联系后台管理员。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/user.js'
export default {
  name: 'login',
  props: {},
  data () {
    return {
      user: {
        username: '',
        password: ''
      }
    }
  },
  computed: {},
  created () { },
  mounted () { },
  watch: {},
  methods: {
    async handleLogin () {
      if (this.username === '' && this.password === '') {
        return this.$toast('请填写账号和密码')
      } else {
        const data = await login(this.user)
        if (data.error_code === 1) {
          this.$store.commit('setUser', data.data.token)
          this.$toast(data.msg)
          setTimeout(() => {
            this.$router.push('/')
          }, 2000)
        } else {
          this.$toast(data.msg)
        }
      }
    }
  },
  components: {}
}
</script>

<style scoped lang="less">
.login {
  overflow-x: hidden;
  height: 100%;
  .personal-head {
    height: 474px;
    position: relative;
  }

  .personal-head:after {
    background: linear-gradient(
      -71deg,
      rgba(45, 173, 177, 1) 0%,
      rgba(60, 228, 220, 1) 100%
    ) !important;
    content: "";
    width: 140%;
    height: 474px;
    position: absolute;
    left: -20%;
    top: 0;
    z-index: -1;
    border-radius: 0 0 50% 50%;
  }

  .head {
    font-size: 30px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    padding: 30px 0 113px 0;
  }
  .logo {
    width: 442px;
    height: 150px;
    margin: 0 auto;
    margin-bottom: 234px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .w580 {
    width: 580px;
    margin: 0 auto;
  }

  /deep/ .van-cell {
    padding: 0;
    height: 96px;
    box-shadow: 0px 5px 13px 0px rgba(15, 15, 15, 0.28);
    background-color: #ffffff;
    margin-bottom: 36px;
    img {
      height: 48px;
    }
  }
  /deep/.back-tran {
    .van-field__control {
      height: 96px;
    }
  }
  /deep/ .van-button {
    margin: 60px auto;
    box-shadow: 0px 5px 13px 0px rgba(15, 15, 15, 0.28);
  }
  p {
    font-size: 26px;
    color: #666666;
    text-align: center;
  }
}
</style>
